import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { ApiSchemasService } from '../services/api-schemas.service';
import { inject } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { ApiSchema } from '../../../../definitions/apis/api-schema';

export const apiSchemaResolver: ResolveFn<ApiSchema> = (
	route: ActivatedRouteSnapshot
): Observable<ApiSchema> => {
	const apiSchemasSvc = inject(ApiSchemasService);
	const schemaId = route.paramMap.get('schemaId');
	return schemaId
		? apiSchemasSvc.find(schemaId).pipe(catchError(() => of(null)))
		: of(null);
};
